import React from 'react';

/**
 * Blocks pointer events on map / lists / controls while the dashboard countdown runs.
 * Must render inside the map shell, below CountryInfoPanel (z-40).
 */
const InteractionShield = ({ active }) => {
  if (!active) return null;

  return (
    <div
      className="pointer-events-auto absolute inset-0 z-[38] cursor-not-allowed bg-vervestacks-dark-blue/15 backdrop-blur-[1px]"
      role="presentation"
      aria-label="Opening dashboard, please wait"
    />
  );
};

export default React.memo(InteractionShield);
